/*
layers to be presented in the project detail page sidebar
for now i only added norwegian sources, as didn not research enough in other countries.
*/
const infoLayers = {
	"Latvia": [
		{
			name: "Cadastral",
			icon: "ri-octagon-line",
			defaultOpen:false,
			layers: [
				{
					id: "cadastral-lv",
					name: "Cadastral units",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-cadastral-tiles'
					},
					layer:{
						'id': 'cadastral-lv-layer',
						'type': 'line',
						'source': 'cadastral-lv',
						'source-layer': 'latvia_cadastral',
						'layout': {
						
						},
						'paint': {
							'line-color': '#BF69A2',
							'line-width': 1
						}
					}
				},
				{
					id: "cadastral-lv-label",
					name: "Cadastral units labels",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-cadastral-tiles'
					},
					layer:{
						'id': 'cadastral-lv-label-layer',
						'type': 'symbol',
						'source': 'cadastral-lv-label',
						'source-layer': 'latvia_cadastral',
						'layout': {
						
						},
						paint: {
						    "text-color": "#BF69A2"
						  },
						'layout': {
							'text-field': ['get', 'CODE'],
							
							'text-justify': 'auto',
							'text-size': 12
						}
					}
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_lv,cadastral.1/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.1',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_lv',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.1',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.1',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
			]
		},
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			layers: [
				{
					id: "grid-lv",
					name: "Power lines",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-grid-tiles'
					},
					layer:{
						'id': 'grid-lv-layer',
						'type': 'line',
						'source': 'grid-lv',
						'source-layer': 'latvia_grid',
						'layout': {
						
						},
						'paint': {
							'line-color': [
								'case',
								['==', ['get', 'voltage'], '330000'],
								'#60759F',
								['==', ['get', 'voltage'], '110000'],
								'#60759F',
								['==', ['get', 'voltage'], '330000;110000'],
								'#377CA4',
								'#889ADD'
							],
							'line-opacity': [
								'case',
								['==', ['get', 'voltage'], '330000'],
								1,
								['==', ['get', 'voltage'], '110000'],
								1,
								['==', ['get', 'voltage'], '330000;110000'],
								1,
								0
							],
							'line-width': 3
						}
					}
				},
				{
					id: "grid-lv-label",
					name: "Power lines label",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-grid-tiles'
					},
					layer:{
						'id': 'grid-lv-label-layer',
						'type': 'symbol',
						'source': 'grid-lv-label',
						'source-layer': 'latvia_grid',
						'layout': {
							'text-field': [
								'case',
								['==', ['get', 'voltage'], '330000'],
								'330kV',
								['==', ['get', 'voltage'], '110000'],
								'100kV',
								['==', ['get', 'voltage'], '330000;110000'],
								'110/330kV',
								''
							],
							'symbol-placement': 'line',
							'text-variable-anchor': ['top'],
							'text-radial-offset': 10.5,
							'text-justify': 'auto',
							'text-size': 16,
							
						},
						'paint': {
							'text-halo-width': 2,
							'text-halo-color': "rgba(255,255,255, 0.75)"
						}
					}
				},
				{
					id: "buildings-lv",
					name: "Houses",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-buildings-tiles'
					},
					layer:{
						'id': 'buildings-lv-layer',
						'type': 'fill',
						'source': 'buildings-lv',
						'source-layer': 'latvia_buildings',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#889ADD',
						}
					}
				},
				{
					id: "buildings-buffered-800m-lv",
					name: "Houses buffered 800m",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia_buildings_800m-tiles'
					},
					layer:{
						'id': 'buildings-buffered-800m-lv-layer',
						'type': 'fill',
						'source': 'buildings-buffered-800m-lv',
						'source-layer': 'latvia_buildings_800m-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#9EAAB0',
						}
					}
				},
				{
					id: "railways-lv",
					name: "Railways",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-railway-tiles'
					},
					layer:{
						'id': 'railways-lv-layer',
						'type': 'fill',
						'source': 'railways-lv',
						'source-layer': 'latvia-railway',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#9EAAB0',
						}
					}
				},
				{
					id: "lv-state-roads",
					name: "State roads",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_state_roads/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-state-roads-layer',
							'type': 'line',
							'source': 'lv-state-roads',
							'source-layer': 'lv_state_roads',
							'paint': {
								'line-color': '#000000',
								'line-width': 3
							}
						}
					]
				},
				{
					id: "lv-state-roads-buffered",
					name: "State roads buffered 300m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_state_roads_buffered_300m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-state-roads-buffered-layer',
							'type': 'fill',
							'source': 'lv-state-roads-buffered',
							'source-layer': 'lv_state_roads_buffered_300m',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.6
							}
						}
					]
				},
				{
					id: "lv-communal-buffered",
					name: "Municipality roads buffered 100m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_communal_buffered_100m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-communal-buffered-layer',
							'type': 'fill',
							'source': 'lv-communal-buffered',
							'source-layer': 'lv_communal_buffered_100m',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.6
							}
						}
					]
				},
			]
		},
		{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "forest-lv",
					name: "Forest",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-forest-tiles'
					},
					layer:{
						'id': 'forest-lv-layer',
						'type': 'fill',
						'source': 'forest-lv',
						'source-layer': 'latvia_forest',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 0.9
						}
					}
				},
				{
					id: "nature-reserves-lv",
					name: "Nature Reserves",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-nature-reserves-tiles'
					},
					layer:{
						'id': 'nature-reserves-lv-layer',
						'type': 'fill',
						'source': 'nature-reserves-lv',
						'source-layer': 'latvia_nature_reserves',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 0.8
						}
					}
				},
				
				{
					id: "natura-2000-source",
					name: "Natura 2000",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.natura-2000-tiles'
					},
					layer:{
						'id': 'natura-2000-source-layer',
						'type': 'fill',
						'source': 'natura-2000-source',
						'source-layer': 'natura-2000-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#8fce00'
						}
					}
				},
				{
					id: "lv-natura2000-buffer-source",
					name: "Natura 2000 buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-natura2000-buffer-tiles'
					},
					layer:{
						'id': 'lv-natura2000-buffer-source-layer',
						'type': 'fill',
						'source': 'lv-natura2000-buffer-source',
						'source-layer': 'lv-natura2000-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#50957F'
						}
					}
				}
			]
		},
		{
			name: "Wind",
			icon: "ri-windy-line",
			layers: [
				{
					id: "wind-lv-raster",
					name: "Wind map (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-lv-raster-layer",
						type: "raster",
						source: "wind-lv-raster",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-lv-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-lv-150m-layer",
						type: "raster",
						source: "wind-lv-150m",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-lv",
					name: "Wind map (vector 100m)",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-wind-gridded-tiles'
					},
					layer:{
						'id': 'wind-lv-layer',
						'type': 'fill',
						'source': 'wind-lv',
						'source-layer': 'latvia_wind_gridded',
						'layout': {
						
						},
						'layout': {
						},
						'paint': {
							'fill-color': [
							  "interpolate",
							  ["linear"],
							  ['get', '_mean'],
							  6.4,
							  "#ffffff",
							  6.5,
							  "#ffefef",
							  6.6,
							  "#ffdfdf",
							  6.7,
							  "#ffcfcf",
							  6.8,
							  "#ffbfbf",
							  6.9,
							  "#ffafaf",
							  7,
							  "#ff9f9f",
							  7.1,
							  "#ff8f8f",
							  7.2,
							  "#ff8080",
							  7.3,
							  "#ff7070",
							  7.4,
							  "#ff6060",
							  7.5,
							  "#ff5050",
							  7.6,
							  "#ff4040",
							  7.7,
							  "#ff3030",
							  7.8,
							  "#ff2020",
							  7.9,
							  "#ff1010",
							  8,
							  "#ff0000"
							],
							'fill-opacity': [
								'case',
								['<', ['get', '_mean'], 6.5],
								0,
								['<', ['get', '_count'], 0],
								0,
								1
							]
						}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				}
			]
		},
		{
			name: "Administrative boundaries",
			icon: "ri-community-line",
			layers: [
				{
					id: "municipality-borders-lv",
					name: "Municipality borders",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-municipalities-tiles'
					},
					layer:{
						'id': 'municipality-borders-lv-layer',
						'type': 'line',
						'source': 'municipality-borders-lv',
						'source-layer': 'latvia_municipalities',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2,
							'line-opacity': 0.9
						}
					}
				},
				{
					id: "municipality-borders-label-lv",
					name: "Municipality labels",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-municipalities-tiles'
					},
					layer:{
						'id': 'municipality-borders-label-lv-layer',
						'type': 'symbol',
						'source': 'municipality-borders-label-lv',
						'source-layer': 'latvia_municipalities',
						'layout': {
							'text-field': ['get', 'LABEL'],
							'text-variable-anchor': ['center'],
							'text-justify': 'auto',
							'text-size': 24
						},
						'paint': {
							
						}
					}
				},
			]
		},
		{
			name: "Nicgale",
			layers: [
				{
					id: "nicgale-allowed-areas",
					name: "Allowed areas",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.00jtw6r0'
					},
					layer:{
						'id': 'nicgale-allowed-areas-layer',
						'type': 'fill',
						'source': 'nicgale-allowed-areas',
						'source-layer': 'allowed_areas-5tf1kw',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "nicgale-cleared-forest",
					name: "Cleared forest",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.aprhn143'
					},
					layer:{
						'id': 'nicgale-cleared-forest-layer',
						'type': 'fill',
						'source': 'nicgale-cleared-forest',
						'source-layer': 'cleared_forest-cz6b0x',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				}
			]
		},
		{
			name: "Puikule",
			layers: [
				{
					id: "puikule-putnu-buffer-outer",
					name: "Birds nest red zone",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikle-putnu-tiles'
					},
					layer:{
						'id': 'puikule-putnu-buffer-layer-red-zone',
						'type': 'fill',
						'source': 'puikule-putnu-buffer-outer',
						'source-layer': 'lv-puikle-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#FF0000',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "puikule-putnu-buffer",
					name: "Birds buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikle-putnu-tiles'
					},
					layer:{
						'id': 'puikule-putnu-buffer-layer',
						'type': 'fill',
						'source': 'puikule-putnu-buffer',
						'source-layer': 'lv-puikle-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						},
						filter: ['!=', 'Liegums', 'Sarkans'],
					}
				},
				{
					id: "puikule-watercourse-buffer",
					name: "Watercourse buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikule-watercourse-tiles'
					},
					layer:{
						'id': 'puikule-watercourse-buffer-layer',
						'type': 'fill',
						'source': 'puikule-watercourse-buffer',
						'source-layer': 'lv-puikule-watercourse-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "puikule-udentecem",
					name: "Feeding buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikule-udentecem-tiles'
					},
					layer:{
						'id': 'puikule-udentecem-layer',
						'type': 'fill',
						'source': 'puikule-udentecem',
						'source-layer': 'lv-puikule-udentecem-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#696969',
							'fill-opacity': 1
						}
					}
				}
			]
		},
		{
			name: "Venta",
			layers: [
				{
					id: "venta-putnu-buffer-outer",
					name: "Birds nest red zone",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-putnu-tiles'
					},
					layer:{
						'id': 'venta-putnu-buffer-layer-red-zone',
						'type': 'fill',
						'source': 'venta-putnu-buffer-outer',
						'source-layer': 'lv-venta-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#FF0000',
							'fill-opacity': 1
						},
						filter: ['==', 'Liegums', 'Sarkans'],
					}
				},
				{
					id: "venta-putnu-buffer",
					name: "Birds buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-putnu-tiles'
					},
					layer:{
						'id': 'venta-putnu-buffer-layer',
						'type': 'fill',
						'source': 'venta-putnu-buffer',
						'source-layer': 'lv-venta-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						},
						filter: ['!=', 'Liegums', 'Sarkans'],
					}
				},
				{
					id: "venta-watercourse-buffer",
					name: "Watercourse buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-watercourse-tiles'
					},
					layer:{
						'id': 'venta-watercourse-buffer-layer',
						'type': 'fill',
						'source': 'venta-watercourse-buffer',
						'source-layer': 'lv-venta-watercourse-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "venta-udentecem",
					name: "Feeding buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-udentecem-tiles'
					},
					layer:{
						'id': 'venta-udentecem-layer',
						'type': 'fill',
						'source': 'venta-udentecem',
						'source-layer': 'lv-venta-udentecem-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#696969',
							'fill-opacity': 1
						}
					}
				}
			]
		},





		{
			name: "Vecmikeli",
			layers: [
				{
					id: "vecmikeli-putnu-buffer-outer",
					name: "Birds nest red zone",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Putnu_buferzonas_Final_07082024/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-putnu-buffer-layer-red-zone',
						'type': 'fill',
						'source': 'vecmikeli-putnu-buffer-outer',
						'source-layer': 'Vecmikeli_Putnu_buferzonas_Final_07082024',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#FF0000',
							'fill-opacity': 1
						},
						filter: ['==', 'liegums', 'Sarkans'],
					}
				},
				{
					id: "vecmikeli-putnu-buffer",
					name: "Birds buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Putnu_buferzonas_Final_07082024/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-putnu-buffer-layer',
						'type': 'fill',
						'source': 'vecmikeli-putnu-buffer',
						'source-layer': 'Vecmikeli_Putnu_buferzonas_Final_07082024',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						},
						filter: ['!=', 'liegums', 'Sarkans'],
					}
				},
				{
					id: "vecmikeli-watercourse-buffer",
					name: "Watercourse buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Siksparnu_udensteces_200m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-watercourse-buffer-layer',
						'type': 'fill',
						'source': 'vecmikeli-watercourse-buffer',
						'source-layer': 'Vecmikeli_Siksparnu_udensteces_200m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "vecmikeli-udentecem",
					name: "Feeding buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Udentecem_buferzonas_Putni/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-udentecem-layer',
						'type': 'fill',
						'source': 'vecmikeli-udentecem',
						'source-layer': 'Vecmikeli_Udentecem_buferzonas_Putni',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#696969',
							'fill-opacity': 1
						}
					}
				}
			]
		},
		{
			name: "Jaunklidzis",
			layers: [
				{
					id: "lv-jaunklidzis-pv-source",
					name: "Jaunklidzis PV",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_jaunklidzis_pv/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-jaunklidzis-pv-layer',
						'type': 'line',
						'source': 'lv-jaunklidzis-pv-source',
						'source-layer': 'lv_jaunklidzis_pv',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 3
						}
					}
				}
			]
		},
	],
	"Norway" : [
		{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "cabins-600m",
					name: "Cabins 600 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.norway-hytter-600m-tiles'
					},
					layer:{
						'id': 'cabins-600m-layer',
						'type': 'fill',
						'source': 'cabins-600m',
						'source-layer': 'norway_buildings_600m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#889ADD',
							'fill-opacity': 0.9
						}
					}
				},
				{
					id: "houses-600m",
					name: "Houses 600 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.norway-buildings-600m-tiles'
					},
					layer:{
						'id': 'houses-600m-layer',
						'type': 'fill',
						'source': 'houses-600m',
						'source-layer': 'norway_buildings_600m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#CCCCCC',
							'fill-opacity': 0.9
						}
					}
				},
				{
					id: "houses-1000m",
					name: "Houses 1000 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/no_houses_buffered_1000m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'no-houses-1000m-layer',
							'type': 'fill',
							'source': 'houses-1000m',
							'source-layer': 'no_houses_buffered_1000m',
							'paint': {
								'fill-color': ['get', 'color'],
								'fill-opacity': 1,
								'fill-outline-color': '#000000'
							}
						}
					]
				},
				{
					id: "municipalities-no-negative",
					name: "Municipality traffic light",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=no_municipality_traffic_light&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "municipalities-no-negative-layer",
						type: "raster",
						source: "municipalities-no-negative",
						paint: {}
					}
				},
				{
					id: "competitors",
					name: "Competitors projects",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitors-layer',
						'type': 'circle',
						'source': 'competitors',
						'source-layer': 'competitors',
						'layout': {
						
						},
						'paint': {
							'circle-color': '#FF0000',
							'circle-radius': 10
						}
					}
				},
				
			]
		},
		{
			name: "Wind",
			icon: "ri-windy-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "wind-no",
					name: "Wind data (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-no-layer",
						type: "raster",
						source: "wind-no",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-no-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-no-150m-layer",
						type: "raster",
						source: "wind-no-150m",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				
			]
		},
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "power-lines",
					name: "Power lines",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.no-grid-tiles'
					},
					layer:{
						'id': 'power-lines-layer',
						'type': 'line',
						'source': 'power-lines',
						'source-layer': 'no-grid-source',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2
						}
					}
				},
				{
					id: "substations",
					name: "Substations",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.no-substations-tiles'
					},
					layer:{
						'id': 'substations-layer',
						'type': 'circle',
						'source': 'substations',
						'source-layer': 'no-substations-source',
						'paint': {
							'circle-color': "#000000",
							'circle-radius': 6
						  },
						'layout': {
							
						}
					}
				},
				{
					id: "substations-name",
					name: "Substations name",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.no-substations-tiles'
					},
					layer:{
						'id': 'substations-layer-name',
						'type': 'symbol',
						'source': 'substations-name',
						'source-layer': 'no-substations-source',
						'paint': {
						    "text-color": "#000000"
						  },
						'layout': {
							'text-field': ['get', 'navn'],
							'text-justify': 'auto',
							'text-size': 14,
							'text-offset': [0.5,0],
							'text-anchor': 'left'
						}
					}
				}
				
			]
		},
		{
			name: "Cadastral",
			icon: "ri-octagon-line",
			defaultOpen:false,
			layers: [
				{
					id: "cadastral-no",
					name: "Properties",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.norway-cadastral-units-tiles'
					},
					layer:[
						{
							'id': 'cadastral-no-layer',
							'type': 'line',
							'source': 'cadastral-no',
							'source-layer': 'norway_cadastral_units',
							'layout': {

							},
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-no-label-layer',
							'type': 'symbol',
							'source': 'cadastral-no',
							'source-layer': 'norway_cadastral_units',
							'layout': {

							},
							paint: {
								"text-color": "#3477eb"
							},
							'layout': {
								'text-field': ['get', 'matrikkeln'],

								'text-justify': 'auto',
								'text-size': 12
							}
						}
					]
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_no,cadastral.2/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.2',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_no',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.2',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.2',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				},
				{
					id: "martin",
					name: "testing",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/no_houses_buffered_1000m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'no_houses_buffered_1000m',
							'type': 'fill',
							'source': 'martin',
							'source-layer': 'no_houses_buffered_1000m'
						},
						
					]
				}
				
				
				
				
				
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		
		{
			name: "Zoning plans",
			icon: "ri-map-2-line",
			layers: [
				{
					id: "zoning-plans",
					name: "Zoning plans",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.geonorge.no/skwms1/wms.reguleringsplaner?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=Vertikalniva2&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "zoning-plans-layer",
						type: "raster",
						source: "zoning-plans",
						paint: {}
					}
				},
				{
					id: "municipal-master-plans",
					name: "Municipal master plans",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.geonorge.no/skwms1/wms.kommuneplaner?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=Kommuneplan&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "municipal-master-plans-layer",
						type: "raster",
						source: "municipal-master-plans",
						paint: {}
					}
				},
				// Kommune status - wms
				/*{
					id: "municipal-status-windpower",
					name: "Municipal status wind",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://vindrtech.com/mapserver?map=/mapserver/test.map?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=municipalities_no&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "municipal-status-windpower-layer",
						type: "raster",
						source: "municipal-status-windpower",
						paint: {}
					}
				},*/
				// Kommunegrenser - tileset
				

			]
		},
		{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "skogbruksplan",
					name: "Skogbruksplan",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.nibio.no/cgi-bin/skogbruksplan?language=nor&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX={bbox-epsg-3857}&CRS=EPSG:3857&WIDTH=1106&HEIGHT=1199&LAYERS=aldersklasser_eldste_skogen&STYLES=&FORMAT=image/png&DPI=72&MAP_RESOLUTION=72&FORMAT_OPTIONS=dpi:72&TRANSPARENT=TRUE",
						],
						tileSize: 256
					},
					layer:{
						id: "skogbruksplan-layer",
						type: "raster",
						source: "skogbruksplan",
						paint: {}
					}
				},
				{
					id: "bestandsalder",
					name: "SR16 Bestandsalder",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.nibio.no/cgi-bin/sr16_beta?language=nor&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX={bbox-epsg-3857}&CRS=EPSG:3857&WIDTH=1106&HEIGHT=1199&LAYERS=SRRBESTANDSALDER&STYLES=&FORMAT=image/png&DPI=72&MAP_RESOLUTION=72&FORMAT_OPTIONS=dpi:72&TRANSPARENT=TRUE",
						],
						tileSize: 256
					},
					layer:{
						id: "bestandsalder-layer",
						type: "raster",
						source: "bestandsalder",
						paint: {}
					}
				},
				{
					id: "pristine-nature",
					name: "Pristine nature",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://kart.miljodirektoratet.no/geoserver/inngrepsfrinatur/ows?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=status&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "pristine-nature-layer",
						type: "raster",
						source: "pristine-nature",
						paint: {}
					}
				},
				{
					id: "nature-reserves-norway",
					name: "Nature reserves",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://kart.miljodirektoratet.no/arcgis/services/vern_hovedtyper/mapserver/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=naturvern_klasser_omrade&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "nature-reserves-norway-layer",
						type: "raster",
						source: "nature-reserves-norway",
						paint: {}
					}
				},
				{
					id: "outdoor-recreation",
					name: "Outdoor recreation",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://kart.miljodirektoratet.no/arcgis/services/friluftsliv_kartlagt/mapserver/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=friluftsliv_kartlagt_verdi&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "outdoor-recreation-layer",
						type: "raster",
						source: "outdoor-recreation",
						paint: {}
					}
				},

			]
		}
	],
	"Estonia" : [
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			defaultOpen:false,
			layers: [
				{
					id: "grid-ee-300",
					name: "Power lines 330kV",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-grid-tiles'
					},
					layer:{
						'id': 'grid-ee-300-layer',
						'type': 'line',
						'source': 'grid-ee-300',
						'source-layer': 'estonia_grid',
						'layout': {
						
						},
						filter: ['==', 'nimipinge', 330],
						'paint': {
							'line-color': '#000000',
							'line-width': 6,
						}
					}
				},
				{
					id: "grid-ee-110",
					name: "Power lines 110kV",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-grid-tiles'
					},
					layer:{
						'id': 'grid-ee-110-layer',
						'type': 'line',
						'source': 'grid-ee-110',
						'source-layer': 'estonia_grid',
						'layout': {
						
						},
						filter: ['==', 'nimipinge', 110],
						'paint': {
							'line-color': '#000000',
							'line-width': 4,
						}
					}
				},
				{
					id: "grid-minor-ee",
					name: "Power lines <= 35kV",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-grid-minor-tiles'
					},
					layer:{
						'id': 'grid-minor-ee-layer',
						'type': 'line',
						'source': 'grid-minor-ee',
						'source-layer': 'estonia_grid_minor',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2,
						}
					}
				},
				{
					id: "residential-buildings-ee",
					name: "Residential buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee',
						'source-layer': 'ee_residential_buildings',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#0000FF',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "buildings-ee",
					name: "Buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-buildings-tiles'
					},
					layer:{
						'id': 'buildings-ee-layer',
						'type': 'fill',
						'source': 'buildings-ee',
						'source-layer': 'buildings-estonia-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1000m",
					name: "Residential buildings buffer 1000m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1000m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1000m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1000m',
						'source-layer': 'ee_residential_buildings_buffered_1000m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1200m",
					name: "Residential buildings buffer 1200m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1200m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1200m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1200m',
						'source-layer': 'ee_residential_buildings_buffered_1200m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1500m",
					name: "Residential buildings buffer 1500m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1500m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1500m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1500m',
						'source-layer': 'ee_residential_buildings_buffered_1500m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1700m",
					name: "Residential buildings buffer 1700m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1700m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1700m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1700m',
						'source-layer': 'ee_residential_buildings_buffered_1700m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "roads-ee",
					name: "Roads minor",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-roads-tiles'
					},
					layer:{
						'id': 'roads-ee-layer',
						'type': 'line',
						'source': 'roads-ee',
						'source-layer': 'road-estonia-source',
						'layout': {
						
						},
						'paint': {
							'line-color': "hsl(0, 0%, 49%)",
							'line-width': 2
						},
						filter: ['in', 'tyyp', 40, 45, 50, 60, 70, 80],
					}
				},
				{
					id: "roads-major-ee",
					name: "Roads major",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-roads-tiles'
					},
					layer:{
						'id': 'roads-major-ee-layer',
						'type': 'line',
						'source': 'roads-major-ee',
						'source-layer': 'road-estonia-source',
						'layout': {
						
						},
						'paint': {
							'line-color': [
							  "match",
							  ["get", "tyyp"],
							  [30],
							  "hsl(60, 93%, 61%)",
							  [20, 10],
							  "hsl(37, 98%, 54%)",
							  "hsl(0, 0%, 49%)"
							],
							'line-width': [
							  "match",
							  ["get", "tyyp"],
							  [10],
							  7,
							  [30],
							  4,
							  3
							]
						},
						filter: ['in', 'tyyp', 30, 20, 10],
					}
				}
			]
		},
		{
			name: "Cadastral",
			icon: "ri-octagon-line",
			defaultOpen:false,
			layers: [
				{
					id: "cadastral-ee",
					name: "Cadastral units",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-cadastral-tiles'
					},
					layer:{
						'id': 'cadastral-ee-layer',
						'type': 'line',
						'source': 'cadastral-ee',
						'source-layer': 'cadastral-estonia-source',
						'layout': {
						
						},
						'paint': {
							'line-color': '#964B00',
							'line-width': 1,
							'line-opacity': 0.6
						}
					}
				},
				{
					id: "cadastral-ee-label",
					name: "Cadastral id (tunnus)",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-cadastral-tiles'
					},
					layer:{
						'id': 'cadastral-ee-label-layer',
						'type': 'symbol',
						'source': 'cadastral-ee-label',
						'source-layer': 'cadastral-estonia-source',
						'layout': {
						
						},
						paint: {
						    "text-color": "#3477eb"
						  },
						'layout': {
							'text-field': ['get', 'tunnus'],
							
							'text-justify': 'auto',
							'text-size': 12
						}
					}
				},
				{
					id: "cadastral-ee-name-label",
					name: "Cadastral name",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-cadastral-tiles'
					},
					layer:{
						'id': 'cadastral-ee-name-label-layer',
						'type': 'symbol',
						'source': 'cadastral-ee-name-label',
						'source-layer': 'cadastral-estonia-source',
						'layout': {
						
						},
						paint: {
						    "text-color": "#3477eb"
						  },
						'layout': {
							'text-field': ['get', 'l_aadress'],
							
							'text-justify': 'auto',
							'text-size': 12
						}
					}
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_ee,cadastral/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_ee',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		{
			name: "Wind",
			icon: "ri-windy-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "wind-ee",
					name: "Wind data (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-ee-layer",
						type: "raster",
						source: "wind-ee",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-ee-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-ee-150m-layer",
						type: "raster",
						source: "wind-ee-150m",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				}
				
			]
		},
		{
			name: "Competitors",
			icon: "ri-virus-line",
			layers: [


				

				{
					id: "competitor-adepte-ee",
					name: "Adepte",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-adepte-ee-layer',
						'type': 'fill',
						'source': 'competitor-adepte-ee',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#00a57f',
						},
						filter: ['==', 'name', 'adepte'],
					}
				},
				{
					id: "competitor-sunly-ee",
					name: "Sunly",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-sunly-ee-layer',
						'type': 'fill',
						'source': 'competitor-sunly-ee',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#a50026',
						},
						filter: ['==', 'name', 'sunly'],
					}
				},
				{
					id: "competitor-eleon-ee",
					name: "Eleon",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-eleon-ee-layer',
						'type': 'fill',
						'source': 'competitor-eleon-ee',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#d73027',
						},
						filter: ['==', 'name', 'eleon'],
					}
				},
				{
					id: "competitor-enery",
					name: "Enery",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-enery-layer',
						'type': 'fill',
						'source': 'competitor-enery',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f46d43',
						},
						filter: ['==', 'name', 'enery'],
					}
				},
				{
					id: "competitor-evecon",
					name: "Evecon",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-evecon-layer',
						'type': 'fill',
						'source': 'competitor-evecon',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#fdae61',
						},
						filter: ['==', 'name', 'evecon'],
					}
				},
				{
					id: "competitor-sustainable-investments",
					name: "Sustainable Investments",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-sustainable-investments-layer',
						'type': 'fill',
						'source': 'competitor-sustainable-investments',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#fee090',
						},
						filter: ['==', 'name', 'sustainable_investments'],
					}
				},
				{
					id: "competitor-utilitas",
					name: "Utilitas",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-utilitas-layer',
						'type': 'fill',
						'source': 'competitor-utilitas',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#ffffbf',
						},
						filter: ['==', 'name', 'utilitas'],
					}
				},
				{
					id: "competitor-enefit-green",
					name: "Enefit Green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-enefit-green-layer',
						'type': 'fill',
						'source': 'competitor-enefit-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#e0f3f8',
						},
						filter: ['==', 'name', 'enefit_green'],
					}
				},
				{
					id: "competitor-eurowind",
					name: "Eurowind",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-eurowind-layer',
						'type': 'fill',
						'source': 'competitor-eurowind',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4a6a75',
						},
						filter: ['==', 'name', 'eurowind'],
					}
				},
				{
					id: "competitor-kc-energy",
					name: "KC Energy",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-kc-energy-layer',
						'type': 'fill',
						'source': 'competitor-kc-energy',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#74add1',
						},
						filter: ['==', 'name', 'kc_energy'],
					}
				},
				{
					id: "competitor-tmw-green",
					name: "TMV Green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-tmw-green-layer',
						'type': 'fill',
						'source': 'competitor-tmw-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4575b4',
						},
						filter: ['==', 'name', 'tmv_green'],
					}
				},
				{
					id: "competitor-ignitis-green",
					name: "Ignitis",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-ignitis-green-layer',
						'type': 'fill',
						'source': 'competitor-ignitis-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#34858e',
						},
						filter: ['==', 'name', 'ignitis'],
					}
				}
			]
		},
		{
			name: "Landowners",
			icon: "ri-user-line",
			layers: [
				{
					id: "competitor-foreko",
					name: "Foreko",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-competitors-tiles'
					},
					layer:{
						'id': 'competitor-foreko-layer',
						'type': 'fill',
						'source': 'competitor-evecon',
						'source-layer': 'ee-competitors-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#ff0000',
						},
						filter: ['==', 'name', 'Foreko'],
					}
				},
				{
					id: "competitor-vestman",
					name: "Vestman",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-competitors-0724-tiles'
					},
					layer:{
						'id': 'competitor-vestman-layer',
						'type': 'fill',
						'source': 'competitor-vestman',
						'source-layer': 'ee-competitors-0724-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#313695',
						},
						filter: ['==', 'name', 'vestman'],
					}
				}
				
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		{
			name: "Administrative boundaries",
			icon: "ri-community-line",
			layers: [
				{
					id: "counties-ee",
					name: "Counties",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-counties-tiles'
					},
					layer:{
						'id': 'counties-ee-layer',
						'type': 'line',
						'source': 'counties-ee',
						'source-layer': 'ee-counties',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 3
						}
					}
				},
				{
					id: "municipalities-ee",
					name: "Municipalities",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-municipalities-tiles'
					},
					layer:{
						'id': 'municipalities-ee-layer',
						'type': 'line',
						'source': 'municipalities-ee',
						'source-layer': 'ee-municipalities',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2
						}
					}
				},
				{
					id: "settlements-ee",
					name: "Settlements",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-settlements-tiles'
					},
					layer:{
						'id': 'settlements-ee-layer',
						'type': 'line',
						'source': 'settlements-ee',
						'source-layer': 'ee-settlements',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 1
						}
					}
				},
				
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			defaultOpen:false,
			layers: [
				{
					id: "ee-buildings-1000m-buffer",
					name: "1000 m buffer zone from residential and municipal buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-buildings-1000m-buffer-tiles'
					},
					layer:{
						'id': 'ee-buildings-1000m-buffer-layer',
						'type': 'fill',
						'source': 'ee-buildings-1000m-buffer',
						'source-layer': 'ee-buildings-1000m-buffer',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "ee-main-roads-300m-buffer",
					name: "300 m buffer zone from national roads",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-main-roads-300m-buffer-tiles'
					},
					layer:{
						'id': 'ee-main-roads-300m-buffer-layer',
						'type': 'fill',
						'source': 'ee-main-roads-300m-buffer',
						'source-layer': 'ee-main-roads-300m-buffer',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				}
			]
		},
		{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "natura-2000-source",
					name: "Natura 2000",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.natura-2000-tiles'
					},
					layer:{
						'id': 'natura-2000-source-layer',
						'type': 'fill',
						'source': 'natura-2000-source',
						'source-layer': 'natura-2000-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#8fce00'
						}
					}
				}
			]
		},
		{
			name: "Änglema",
			layers: [
				{
					id: "ee-anglema-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_anglema_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-anglema-zones-layer',
						'type': 'fill',
						'source': 'ee-anglema-zones-source',
						'source-layer': 'ee_anglema_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'green']
					},
					
				},
				{
					id: "ee-anglema-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_anglema_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-anglema-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-anglema-zones-yellow-source',
						'source-layer': 'ee_anglema_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'yellow']
					},
				}
			]
		},
		{
			name: "Pärnu",
			layers: [
				{
					id: "ee-parnu-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_parnu_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-parnu-zones-layer',
						'type': 'fill',
						'source': 'ee-parnu-zones-source',
						'source-layer': 'ee_parnu_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'green']
					},
					
				},
				{
					id: "ee-parnu-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_parnu_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-parnu-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-parnu-zones-yellow-source',
						'source-layer': 'ee_parnu_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'yellow']
					},
				}
			]
		},
		{
			name: "Türi (Riigiala)",
			layers: [
				{
					id: "ee-turi-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_turi_zones_1/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-turi-zones-layer',
						'type': 'fill',
						'source': 'ee-turi-zones-source',
						'source-layer': 'ee_turi_zones_1',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'green']
					},
					
				},
				{
					id: "ee-turi-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_turi_zones_1/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-turi-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-turi-zones-yellow-source',
						'source-layer': 'ee_turi_zones_1',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'yellow']
					},
				}
			]
		},

	],
    "Sweden": [
    	{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			defaultOpen:false,
			layers: [
				{
					id: "houses-1000m",
					name: "Houses 1000 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/se_houses_1000m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se-houses-1000m-layer',
							'type': 'fill',
							'source': 'houses-1000m',
							'source-layer': 'se_houses_1000m',
							'paint': {
								'fill-color': '#FF1010',
								'fill-opacity': 0.7
							}
						}
					]
				},
				{
					id: "houses-800m",
					name: "Houses 800 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/se_houses_800m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se_houses_800m-layer',
							'type': 'fill',
							'source': 'houses-800m',
							'source-layer': 'se_houses_800m',
							'paint': {
								'fill-color': '#8C145A',
								'fill-opacity': 0.7
							}
						}
					]
				},
				{
					id: "houses-600m",
					name: "Houses 600 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/se_houses_600m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se_houses_600m-layer',
							'type': 'fill',
							'source': 'houses-600m',
							'source-layer': 'se_houses_600m',
							'paint': {
								'fill-color': '#1919A4',
								'fill-opacity': 0.7
							}
						}
					]
				},
			]
		},
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			defaultOpen:false,
			layers: [
				{
					id: "se-residential",
					name: "Residential houses",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/buildings/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se-residential-layer',
							'type': 'fill',
							'source': 'se-residential',
							'source-layer': 'buildings',
							'paint': {
								'fill-color': '#ff0000',
								'fill-opacity': 0.7
							},
							filter: ['==', 'objekttyp', 'Bostad'],
						}
					]
				},
				{
					id: "se-buildings",
					name: "Buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/buildings/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se-buildings-layer',
							'type': 'fill',
							'source': 'se-buildings',
							'source-layer': 'buildings',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.7
							}
						}
					]
				}
			]
		},
    	{
			name: "Cadastral",
			icon: "ri-octagon-line",
			layers: [
				{
					id: "cadastral-units-se",
					name: "Cadastral units",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=sweden_fastighet&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "cadastral-units-se-layer",
						type: "raster",
						source: "cadastral-units-se",
						paint: {}
					}
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_se,cadastral.3/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.3',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_se',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.3',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.3',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
			]
		},
		{
			name: "Wind",
			icon: "ri-octagon-line",
			layers: [
				{
					id: "wind-se",
					name: "Wind data (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-layer",
						type: "raster",
						source: "wind-se",
						paint: {}
					}
				},
				{
					id: "wind-se-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-150m-layer",
						type: "raster",
						source: "wind-se-150m",
						paint: {}
					}
				},
				{
					id: "wind-se-125m",
					name: "Wind data (125m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_se&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-125-layer",
						type: "raster",
						source: "wind-se-125m",
						paint: {}
					}
				},
				{
					id: "wind-se-125m-d",
					name: "Wind data (125m D)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_se_d&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-125m-d-layer",
						type: "raster",
						source: "wind-se-125m-d",
						paint: {}
					}
				},
			]
		},
    	{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "natura-2000-source",
					name: "Natura 2000",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.natura-2000-tiles'
					},
					layer:{
						'id': 'natura-2000-source-layer',
						'type': 'fill',
						'source': 'natura-2000-source',
						'source-layer': 'natura-2000-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#8fce00'
						}
					}
				}
			]
		},
		{
			name: "Other",
			icon: "ri-circle-line",
			defaultOpen:false,
			layers: [
				{
					id: "se-price-areas-source",
					name: "Price regions",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.se-price-areas-tiles'
					},
					layer:{
						'id': 'se-price-areas-source-layer',
						'type': 'fill',
						'source': 'se-price-areas-source',
						'source-layer': 'se-price-areas-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': [
								'case',
								['==', ['get', 'Namn'], 'SE1'],
								'#edf8fb',
								['==', ['get', 'Namn'], 'SE2'],
								'#b2e2e2',
								['==', ['get', 'Namn'], 'SE3'],
								'#66c2a4',
								'#238b45'
							],
							'fill-opacity': 0.6,
							'fill-outline-color': '#000000',
						}
					}
				}
			]
		}
    ],
    
	"All" : [
		
	],
	"compile" : function(country) {
		
		var output = [];
		if(this[country]){
			output = JSON.parse(JSON.stringify(this[country])); // clone the country layers
			
			this.All.map((section)=>{
				var idx = -1;
				if((idx = output.findIndex((sec)=>sec.name == section.name)) != -1 ){
					output[idx].layers.push(...section.layers);
				}
				else
					output.push(section)
			});
			
		}
		else
			output = this.All;
		this.currentSet = output;
		
		return this;
	},
	"countries" : function(country) {
		
		var copy = {...this};
		var output = [];
		delete copy.compile;
		delete copy.currentSet
		delete copy.countries
		
		var countries = Object.getOwnPropertyNames(copy);
		countries.map((country)=>{
			output.push({
				name: country,
				sections:copy[country]
			});
		})
		
		
		return output;
	},
	"currentSet":[],
}





export { infoLayers };


